import { LeverageBadge, OrderSideBadge } from '@flipster/features/src/misc/badge';
import { SymbolDisplay } from '@flipster/features/src/misc/display';
import { Price } from '@flipster/ui';
import { OrderMarginType, V2OrderSideType } from '@flipster/utils/types/base';

import styles from '../tpslModal.module.scss';

interface Props {
  symbol: string;
  displayPrice?: string;
  pricePrecision: number;
  side: V2OrderSideType;
  leverage: number;
  marginType?: OrderMarginType;
}

const SymbolInfo = ({ symbol, displayPrice, pricePrecision, side, leverage, marginType }: Props) => {
  return (
    <div className={styles.symbolInfo}>
      <SymbolDisplay
        css={{ flex: 1 }}
        symbol={symbol}
        icon={<SymbolDisplay.Icon size={32} space={8} />}
        mainLabel={<SymbolDisplay.Label value='shortName' css={{ textStyle: 'Text/L/Strong' }} />}
        subLabel={
          <Price
            method='round-half-up'
            fontType='num3'
            price={displayPrice}
            precision={pricePrecision}
            className={styles.symbolIconPrice}
            toFixed
          />
        }
      />
      <OrderSideBadge orderSide={side} />
      <LeverageBadge leverage={leverage} marginType={marginType} />
    </div>
  );
};

export default SymbolInfo;
